import React, { useContext, useEffect, useState } from "react";
import { Grid, List, ListItem, ListItemText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import FacebookProfilesDashboardContext from "../../../context/facebook_profiles/dashboard/DashboardContext";

// Components
import Error from "./Error_00";
import Form from "./Form/Form_00";
import Stats from "./AdsManager/Stats_00";
import Business from "./BusinessInfo/Info_00";
import Campaign from "./Campaign/Create";
import AdSet from "./AdSet/Create";
import Ad from "./Ad/Create";

const useStyles = makeStyles((theme) => ({
  // root: { maxHeight: 400 },
  // root_stats: { maxHeight: 700 },
  root: {
    height: 700,
  },
  grid: {
    height: "100%",
  },
  list: {
    width: "100%",
    height: "100%",
    minHeight: 364,
    backgroundColor: theme.palette.background.paper,
    position: "relative",
    overflow: "auto",
    border: "1px solid silver",
    borderRadius: "5px",
    marginBottom: "1rem",
  },
  listItem: {
    backgroundColor: "inherit",
    paddingTop: "1px",
    paddingBottom: "1px",
  },
}));

const DashboardDisplay = () => {
  const classes = useStyles();

  const {
    profiles,
    profiles_filtered,
    selected_profile,
    getProfile,
    // selected_fb_details,
    // campaign_stats,
    toggle_ads,
    setToggleAds,
    display_content,
    setDisplayContent,
    setCurrentTab,
    setStatsFilter,
  } = useContext(FacebookProfilesDashboardContext);

  // const [long_page, setLongPage] = useState(false);
  const [profile_list, setProfileList] = useState([]);

  const onChangeProfile = (profile_id) => {
    // Append Profile ID to URL Without Reload
    const html = document.getElementById("root").innerHTML;
    const pageTitle = document.title;
    const urlPath =
      window.location.origin + "/facebook/profile" + `/${profile_id}`;

    window.history.pushState(
      {
        html,
        pageTitle,
      },
      "",
      urlPath
    );

    // Get Profile
    getProfile(profile_id);

    // Change To Default
    // (Overview - Ads Manager)
    setToggleAds(true);
    // (Overview - Ads Manager - Stats)
    setDisplayContent();
    // (Stats - Campaign)
    setCurrentTab("Campaign");
    // (Stats - Date Filter - Today)
    setStatsFilter("stats_date_filter", {
      startDate: "",
      endDate: "",
    });
    // (Stats - Delivery Filter - All)
    setStatsFilter("stats_delivery_filter", {
      current_tab: "",
      status: "",
    });
    // (Stats - Name Filter - Empty)
    setStatsFilter("stats_name_filter", {
      current_tab: "",
      text: "",
    });
  };

  useEffect(() => {
    if (profiles_filtered) setProfileList(profiles_filtered);
    else setProfileList(profiles);
  }, [profiles, profiles_filtered]);

  return (
    <Grid item xs={12} container direction="column">
      <Grid
        item
        container
        className={classes.root}
      >
        {/* Profile List */}
        <Grid
          item
          xs={2}
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          className={classes.grid}
        >
          <List className={classes.list}>           
            {profile_list.map((each, index) => {
              return (
                <ListItem
                  key={index}
                  className={classes.listItem}
                  button
                  autoFocus={
                    !profiles_filtered &&
                    selected_profile &&
                    selected_profile.profile_id === each.profile_id
                  }
                  selected={
                    selected_profile &&
                    selected_profile.profile_id === each.profile_id
                  }
                  onClick={() => onChangeProfile(each.profile_id)}
                >
                  <ListItemText primary={each.profile_id} />
                </ListItem>
              );
            })}
          </List>
        </Grid>
        {/* Form */}
        {selected_profile && (
          <Grid
            item
            xs={10}
            container
            justifyContent="center"
            alignItems="flex-start"
            className={classes.grid}
          >
            <Grid item xs={12} className={classes.grid}>             
              {selected_profile.error && selected_profile.error.message ? (
                <Error />
              ) : !display_content && (
                <Grid item className={classes.grid}>
                  <Form /> 
                  {/* {toggle_ads ? <Stats /> : <Business />} */}
                </Grid>
              )} 
              {/* : (
                 <Grid item className={classes.grid}>                 
                   {display_content === "Campaign" && <Campaign />}
                   {display_content === "Ad Set" && <AdSet />}
                   {display_content === "Ad" && <Ad />}
                 </Grid>
              ) */}
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default DashboardDisplay;
